import React from "react";
import "./spinner.css";

const spinner = (props) => {
  return <div className="Loader">Loading...</div>;
};

export default spinner;
